"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAddonsCssTransitionGroup = _interopRequireDefault(require("react-addons-css-transition-group"));

require("./fade.css");

/** Simple fade-in css transitions component */
var Fade =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Fade, _React$Component);

  function Fade() {
    (0, _classCallCheck2.default)(this, Fade);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Fade).apply(this, arguments));
  }

  (0, _createClass2.default)(Fade, [{
    key: "render",
    value: function render() {
      var timeOut = this.props.transitionAppearTimeout;
      return _react.default.createElement(_reactAddonsCssTransitionGroup.default, {
        transitionName: "fade-wrap",
        transitionAppear: true,
        transitionAppearTimeout: timeOut,
        transitionEnter: false,
        transitionLeave: false
      }, this.props.children);
    }
  }]);
  return Fade;
}(_react.default.Component);

exports.default = Fade;
Fade.propTypes = {
  /** The children element(s) you want to fade in */
  children: _propTypes.default.element.isRequired,

  /** Duration of the "fade-in" in milliseconds */
  transitionAppearTimeout: _propTypes.default.number
};
Fade.defaultProps = {
  transitionAppearTimeout: 500
};